export const shuffle = (items) => {
	const shuffledItems = [...items];
	for (let index = shuffledItems.length - 1; index > 0; index--) {
		const randomIndex = Math.floor(Math.random() * (index + 1));
		[shuffledItems[index], shuffledItems[randomIndex]] = [
			shuffledItems[randomIndex],
			shuffledItems[index],
		];
	}
	return shuffledItems;
};

export const applyWheelDataUpdate = (state, items) => {
	if (!state.isNotLocked) {
		return;
	}

	state.wheelData = items;
	state.totalCost = items.reduce(
		(totalCost, currentItem) => totalCost + currentItem.cost,
		0,
	);
};
